import axios from 'axios'
import { base64StringToBlob } from 'blob-util'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import hostConf from '$config/frontend'
import { closeCurrentModal } from 'weblite-web-modal-viewer'
import { ShareReqPayload } from '@weblite-wapps/protocol'
import { showProcessingMessageLoadingModal } from '$comp/modals/loading-modal'
import { getClientUserIdentityToken } from '$logic/auth'
import { shareInlineWapp } from '$logic/wapp-communication/helper/utils.helper'
import { sendImageMessage } from '$logic/message/service'
import { blobToFile } from '$func/file'
import { showGeneratingImageFailedSnackbar } from '$comp/snackbars'

const LINK_REGEX_STRING =
  '([a-z]+:\\/\\/)?((([^\\s./?#]+\\.)+[^\\s./]+)(\\/\\S*)?)$'

const LINK_REGEX = new RegExp(LINK_REGEX_STRING, 'g')

const PLUGINS = [
  {
    match: new RegExp(`^\/meq (.+)$`),
    handle: async (body: string, roomId: string) => {
      if (!hostConf.MEQIAS_PLUGIN_SERVER) return false

      const prompt = body.slice(5)
      if (!prompt.length) return false

      try {
        axios
          .post<{ images: string[] }>(hostConf.MEQIAS_PLUGIN_SERVER, {
            prompt,
            negative_prompt: '',
            styles: [''],
            seed: 222222,
            subseed: 226198433,
            subseed_strength: 0,
            seed_resize_from_h: -1,
            seed_resize_from_w: -1,
            sampler_name: 'LMS Karras',
            batch_size: 1,
            n_iter: 1,
            steps: 50,
            cfg_scale: 10,
            width: 512,
            height: 512,
            restore_faces: null,
            tiling: false,
            do_not_save_samples: false,
            do_not_save_grid: false,
            eta: 0,
            denoising_strength: 0.7,
            s_min_uncond: 0,
            s_churn: 0,
            s_tmax: 0,
            s_tmin: 0,
            s_noise: 0,
            override_settings: {},
            override_settings_restore_afterwards: false,
            refiner_checkpoint: '',
            refiner_switch_at: 0,
            disable_extra_networks: false,
            firstpass_image: '',
            comments: {},
            enable_hr: false,
            firstphase_width: 0,
            firstphase_height: 0,
            hr_scale: 2,
            hr_upscaler: '',
            hr_second_pass_steps: 0,
            hr_resize_x: 0,
            hr_resize_y: 0,
            hr_checkpoint_name: 'Use same checkpoint',
            hr_sampler_name: 'Use same sampler',
            hr_prompt: '',
            hr_negative_prompt: '',
            force_task_id: '',
            sampler_index: '',
            script_name: '',
            script_args: [],
            send_images: true,
            save_images: false,
            alwayson_scripts: {},
            infotext: '',
          })
          .then(async res => {
            const images = res.data?.images || []
            if (!images.length) return

            const imageBlob = base64StringToBlob(images[0])
            const imageFile = blobToFile(imageBlob, 'generated_image.jpg')

            await sendImageMessage(imageFile, prompt, undefined, roomId)
          })
          .catch(() => {
            showGeneratingImageFailedSnackbar()
          })
      } catch (e) {
        console.error(e)
      }

      return false
    },
  },
  {
    match: new RegExp(`/post( +)${LINK_REGEX_STRING}`),
    handle: async (body: string, roomId: string) => {
      if (!hostConf.POST_COMMAND_PLUGIN_SERVER) return false

      const link = body.match(LINK_REGEX)?.[0]
      if (!link) return false
      const token = await getClientUserIdentityToken()

      await showProcessingMessageLoadingModal()
      try {
        const res = await axios.post<ShareReqPayload>(
          `${hostConf.POST_COMMAND_PLUGIN_SERVER}/link`,
          { link },
          { headers: { authorization: `Bearer ${token}` } },
        )

        await shareInlineWapp(
          res.data.inlineModeInfo,
          false,
          res.data.contentUri,
        )
        closeCurrentModal()
        return true
      } catch (e) {
        closeCurrentModal()
        console.error(e)
        return false
      }
    },
  },
] as const

export async function handleCommandInMessage(body: string, roomId: string) {
  const plugin = PLUGINS.find(p => p.match.test(body))
  if (!plugin) return false

  return plugin.handle(body, roomId)
}
